import React from 'react'
import { createContext } from 'src/util'
import PropTypes from 'prop-types'

/**
 * Creates a context for D3 components
 */
export default createContext(Provider => {
  function D3Context({ getTransitionDuration, ...props }) {
    return <Provider {...props} value={{ getTransitionDuration }} />
  }

  D3Context.propTypes = {
    getTransitionDuration: PropTypes.func,
  }

  return D3Context
}, {})
